
function copyFields(model, fields) {
    var copy = {}
    fields.forEach(function(name) {
        copy[name] = angular.copy(model[name]);
    });
    return copy;
}

function placementFormDirective(name, fields, addToScope) {
    module.directive(name, /* @ngInject */ function(PlacementService) {
        return {
            restrict: 'E',
            templateUrl: 'students/placements/' + name,
            scope: {placement: '=', student: '='},
            require: '^basicForm',
            link: function(scope, element, attrs, basicForm) {
                scope.data = basicForm.data = copyFields(scope.placement,
                                                         fields);
                scope.form = basicForm.getForm()

                if (addToScope) {
                    angular.extend(scope, addToScope);
                }

                basicForm.save = function(data) {
                    return PlacementService.patchPlacement(scope.placement, data);
                };
            },
        };
    });
}

placementFormDirective('educationInstitutionForm', [
    'institution_name',
    'institution_type',
    'college_type',
    'education_hours',
]);


placementFormDirective('educationPlacementDetailsForm', [
    'credential_goal',
    'credits_earned',
]);


placementFormDirective('educationPlacementApprenticeshipForm', [
    'credits_earned',
    'apprenticeship_wage',
    'apprenticeship_sector',
    'apprenticeship_sponsor',
]);


placementFormDirective('educationPlacementGraduateForm', [
    'degree_earned',
    'field_of_study',
    'credential_name'
], {
    fieldDegrees: ['bachelors', 'associates', 'graduate'],
    credentials: ['technical', 'apprenticeship', 'other'],
})


/******************/
/* Duration Forms */
/******************/

var durationScope = {placement: '=', duration: '=', next: '=', previous: '='};

function durationSave(PlacementService, scope) {
    return function(data) {
        return PlacementService.patchDuration(
            scope.placement,
            scope.duration,
            data);
    }
}

function durationLink(scope, basicForm, fields) {
    scope.data = basicForm.data = copyFields(scope.duration, fields);
    scope.form = basicForm.getForm()
}


module.directive('educationDurationStartDateForm', function(PlacementService) {
    return {
        restrict: 'E',
        templateUrl: 'students/placements/educationDurationStartDateForm',
        scope: durationScope,
        require: '^basicForm',
        link: function(scope, element, attrs, basicForm) {
            durationLink(scope, basicForm, ['education_duration_start']);
            basicForm.save = durationSave(PlacementService, scope);

            function deleteDuration() {
                return PlacementService.deleteDuration(scope.placement,
                                                       scope.duration);
            }

            function canDelete() {
                return angular.isDefined(scope.previous);
            }

            basicForm.setDeleteFunctions(deleteDuration, canDelete);
        }
    }
});


module.directive('educationDurationEndDateForm', function(PlacementService) {
    return {
        restrict: 'E',
        templateUrl: 'students/placements/educationDurationEndDateForm',
        scope: durationScope,
        require: '^basicForm',
        link: function(scope, element, attrs, basicForm) {
            durationLink(scope, basicForm, [
                'education_duration_end',
                'education_duration_reason']);
            scope.form = basicForm.getForm()

            basicForm.save = durationSave(PlacementService, scope);
        }
    }
})


module.directive('educationPlacementDurationForm', function(PlacementService) {
    return {
        restrict: 'E',
        templateUrl: 'students/placements/educationPlacementDurationForm',
        scope: durationScope,
        require: '^basicForm',
        link: function(scope, element, attrs, basicForm) {
            durationLink(scope, basicForm, ['education_duration_end',
                                            'education_duration_start',
                                            'education_duration_reason']);
            scope.form = basicForm.getForm()

            scope.disabledMsg = 'Cannot indicate a graduation if the student ' +
                                'has a following renrollment';

            basicForm.save = durationSave(PlacementService, scope);

            function deleteEndDate() {
                var data = {education_duration_end: null,
                            education_duration_reason: null};

                return PlacementService.patchDuration(
                    scope.placement, scope.duration, data);
            }

            function canDelete() {
                return angular.isUndefined(scope.next);
            }

            basicForm.setDeleteFunctions(deleteEndDate, canDelete);
        }
    }
});


module.directive('newEducationPlacementDurationForm', function(PlacementService) {
    return {
        restrict: 'E',
        templateUrl: 'students/placements/educationDurationStartDateForm',
        scope: {placement: '=', previous: '='},
        require: '^basicForm',
        link: function(scope, element, attrs, basicForm) {
            durationLink(scope, basicForm, []);
            basicForm.save = function(data) {
                return PlacementService.createDuration(scope.placement, data);
            };
        }
    }
})


module.directive('brandeisPlacementForm', function(PlacementService) {
    return {
        restrict: 'E',
        templateUrl: 'students/placements/brandeisPlacementForm',
        scope: {brandeis: '=', placement: '=', isCollege: '='},
        require: '^basicForm',
        link: function(scope, element, attrs, basicForm) {
            scope.data = basicForm.data = angular.copy(scope.brandeis);
            scope.form = basicForm.getForm();

            console.log(scope.isCollege);

            basicForm.save = function(data) {
                return PlacementService.patchBrandeis(scope.brandeis, data);
            }
        }
    }
})